import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Trans, translate } from 'react-i18next';
import { USER_TYPE } from '../../App.js';
import { compose } from 'recompose';
import axios from 'axios';
import * as $ from 'jquery';
import moment from 'moment-timezone';

let cancelToken;
let state;
let tokenSession;

export const ROOM_TYPE = {
  MEETING_ROOM: "1",
  COWORK: "2"
};

const times = [
  { id: "0", time: "08:00", isHiden: false },
  { id: "1", time: "08:30", isHiden: false },
  { id: "2", time: "09:00", isHiden: false },
  { id: "3", time: "09:30", isHiden: false },
  { id: "4", time: "10:00", isHiden: false },
  { id: "5", time: "10:30", isHiden: false },
  { id: "6", time: "11:00", isHiden: false },
  { id: "7", time: "11:30", isHiden: false },
  { id: "8", time: "12:00", isHiden: false },
  { id: "9", time: "12:30", isHiden: false },
  { id: "10", time: "13:00", isHiden: false },
  { id: "11", time: "13:30", isHiden: false },
  { id: "12", time: "14:00", isHiden: false },
  { id: "13", time: "14:30", isHiden: false },
  { id: "14", time: "15:00", isHiden: false },
  { id: "15", time: "15:30", isHiden: false },
  { id: "16", time: "16:00", isHiden: false },
  { id: "17", time: "16:30", isHiden: false },
  { id: "18", time: "17:00", isHiden: false },
  { id: "19", time: "17:30", isHiden: false },
  { id: "20", time: "18:00", isHiden: false },
  { id: "21", time: "18:30", isHiden: false },
  { id: "22", time: "19:00", isHiden: false },
  { id: "23", time: "19:30", isHiden: false },
]

class RoomResevation extends Component {

  getInitState = () => {
    return {
      room: [],
      center: [],
      room_id: "",
      date: "",
      duration: "",
      durations: [],
      _time: "08:00",
      fulltime: false,
      timeof: [],
      roomType: ROOM_TYPE.MEETING_ROOM,
      listDate: [],
      coworkType: 1,
      numDays: 0,
      reservationId: "",
      horas_disponibles: [],
      _horas: [],
    }
  }
  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.reload();
    $('#date').datepicker({
      onSelect: (d, i) => {
        if (d !== i.lastVal) {
          this.handleDateChange(d);
        }
      }
    });
  }

  bookRoom = (params) => {
    this.props.post(
      "/bookRoom",
      params,
      (response) => this.didBookRoom(response),
      (error) => this.didgetError(error),
      cancelToken
    );
  }
  didgetError = (error) => {
    alert(error);
  }

  didBookRoom = (response) => {
    this.setState({ reservationId: response.reservation_id });
  }


  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  reload = () => {
    if (!(this.props.center || this.props.room)) {
      this.getRoom({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession(),
        room_id: this.props.match.params.reservationid,
        ingles: false
      })
    }

    this.getDurations({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  getRoom = (params) => {
    this.props.post(
      "/getroomweb",
      params,
      (response) => this.didGetRoom(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getDurations = (params) => {
    this.props.post(
      "/getDurations",
      params,
      (response) => this.didGetDurations(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getBookRoom = (params) => {
    this.props.post(
      "/getBookRoom",
      params,
      (response) => this.didGetBookTime(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetRoom = (response) => {
    this.setState({ room: response });
  }

  didGetDurations = (response) => {
    let duration = this.state.duration;
    duration = duration ? duration : response[0].id;

    this.setState({
      duration: duration,
      durations: response
    });
  }

  didGetBookTime = (response) => {
    var count = 0
    var horas_disponibles = []
    const duration = parseInt(this.state.duration)
    times.map((times) => times.isHiden = false)
    if (response.msg === "No encontró reservaciones") {
      this.setState({ fulltime: true });
    }
    response.reservations.map((reservation) => {
      const hora_inicial = new Date(reservation.fecha_inicial)
      const hora_final = new Date(reservation.fecha_final)
      times.map((time) => {
        const hora_diponible = new Date(this.state.date + " " + time.time)
        if ((hora_inicial <= hora_diponible && hora_final > hora_diponible)) {
          time.isHiden = true;
        }
      })
      this.setState({ fulltime: true });
    })
    times.map((hour) => {
      if (!hour.isHiden) {
        count++
        horas_disponibles.push(hour.id)
      } else {
        if (count >= duration) {
          if (count === duration) {
            horas_disponibles.map((ids) => times[ids].isHiden = false)
          }
          horas_disponibles.map((ids, index) => { times[ids].isHiden = false })
          count = 0
          horas_disponibles = []
        } else {
          horas_disponibles.map((ids) => times[ids].isHiden = true)
          count = 0
          horas_disponibles = []
        }
      }
    })
    if (count >= duration) {
      if (count === duration) {
        horas_disponibles.map((ids) => times[ids].isHiden = false)
      }
      horas_disponibles.map((ids, index) => { times[ids].isHiden = false })
      count = 0
      horas_disponibles = []
    } else {
      horas_disponibles.map((ids) => times[ids].isHiden = true)
      count = 0
      horas_disponibles = []
    }
    this.setState({ _horas: times })
  }

  handleErrorResponse = (error) => {
    alert(error)
  }

  handleDurationChange = (event) => {
    this.setState({ duration: event.target.value, fulltime: false, reservationId: "" });
  }

  handleDateChange = (date) => {
    this.setState({ date: date, fulltime: false, reservationId: "" });
    times.map((time) => { time.isHiden = false; })
  }

  handleTimeChange = (event) => {
    this.setState({ _time: event.target.value, reservationId: "" });
  }

  handleBookResevations = (event) => {
    event.preventDefault();

    this.getBookRoom({
      id: this.props.match.params.reservationid,
      date: moment(this.state.date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      duration: this.state.duration,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  handleRoomClick = () => {
    this.bookRoom({
      id: this.props.match.params.reservationid,
      date: moment(this.state.date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      time: this.state._time,
      duration: this.state.duration,
      room_type: this.state.roomType,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  handleBookReservation = () => {
    const reservationId = this.state.reservationId;
    return {
      pathname: (this.props.user.no_account ? "/store" : "") + "/reservation/" + reservationId + "/payment",
      state: {
        center: this.props.center,
        reservationId: reservationId,
        room: this.state.room
      }
    }
  }

  render() {
    const { t } = this.props;
    const user = this.props.user;
    const center = this.props.center ? this.props.center : this.state.room;
    const room = this.props.room ? this.props.room : this.state.room;
    const durations = this.state.durations ? this.state.durations : [];
    const date = this.state.date;
    const duration = this.state.duration ? parseInt(this.state.duration) : 0;
    const start_date = this.state._time ? new Date(date+" "+this.state._time) : null;
    return (
      <div className="content-resvations">
        <div className="container-resvations-title">
          <div className="row">
            <div className={user.member != 1 ? "col-md-8" : "col-md-12"}>
              <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
            </div>
          </div>
        </div>
        <div className="container-room">
          <div className="container-room-header card-panel panel panel-default card">
            <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + room.picture + "')" }}>
            </div>
            <div className="card-panel-body">
              <div className="panel-body-title">
                <h4 className="ioscentro">{center.center_name}</h4>
                <h4 className="iossala">{room.name}</h4>
              </div>
              <div className="panel-body-description">
                <div className="panel-description-text">
                  {room.description}
                </div>
                <div className="contenedor-flexbox">
                  <div className="contenedor">
                    <i className="fa fa-users" aria-hidden="true">
                    </i>
                    Capacidad para {room.capacity} personas.
                  </div>

                </div>
                <div className="contenedor-flexbox">
                  {this.props.user.balance === undefined
                    ? (<div className="contenedor">
                      <i className="fa fa-usd" aria-hidden="true"></i>
                      {t('dashboard.reservations.price') + " $" + room.price}
                    </div>)
                    : (null)
                  }
                </div>
                <div className="contenedor-flexbox">
                  <div className="form-group">
                    <label htmlFor="date">
                      {t('dashboard.reservations.label_date')}
                    </label>
                    <input
                      autoComplete="off"
                      className="form-control"
                      id="date"
                      onChange={(e) => this.handleDateChange(e.target.value)}
                      placeholder={t('dashboard.reservations.holder_date')}
                      required
                      type="text"
                      value={this.state.date} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="duration">
                      {t('dashboard.reservations.label_duration')}
                    </label>
                    <select
                      className="form-control"
                      id="duration"
                      onChange={this.handleDurationChange}
                      required
                      value={this.duration}>
                      {durations.map((duration, index) => <option key={index} value={duration.id}>{duration.name}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ marginTop: '26px' }}>
                    {this.state.fulltime ? (
                      <div>
                        <select
                          className="form-control"
                          id="time"
                          onChange={this.handleTimeChange}
                          required
                          value={this.state._time}>
                          {times.map((time, index) => <option className={time.isHiden ? 'hidden' : 'block'} key={index} value={time.time}>{time.time}</option>)}
                        </select>
                      </div>


                    ) : (
                      <button
                        disabled={date ? false : true}
                        className="change_portada"
                        onClick={this.handleBookResevations}
                        type="button">
                        Ver Disponibilidad
                      </button>
                    )}
                  </div>
                  <div className="form-group" style={{ marginTop: '26px' }}>
                    {this.state.fulltime ? (
                      <button
                        disabled={date ? false : true}
                        className="change_portada"
                        onClick={this.handleRoomClick}
                        type="button">
                        Reservar Sala
                      </button>
                    ) : (
                      null
                    )}
                  </div>
                </div>
                {this.state.reservationId ? (
                  <div className="contenedor-blockbox">
                    <div>
                      <h3 className="iossala">
                        FECHA: &ensp;
                        {this.state.date ? this.state.date : ""}
                      </h3>
                    </div>
                    <div>
                      <h3 className="iossala">
                        DURACION: &ensp;
                        {this.state.duration ? durations[duration - 1].name : ""}
                      </h3>
                    </div>
                    <div>
                      <h3 className="iossala">
                        HORA:  &ensp;
                        {this.state._time ? this.state._time : ""}
                      </h3>
                    </div>
                    <div>
                      <Link to={this.handleBookReservation()}>
                        <button
                          className="change_portada"
                          type="button">
                          CONTINUAR CON LA RESERVACION
                        </button>
                      </Link>
                    </div>
                  </div>
                ) : (null)}
              </div>
              <div className="panel-body-bottom">
                <div className="panel-body form-group">
                  {/* <Link to={this.getPaymentLink()}>
                    <button
                      className="btn btn-block btn-primary  btn-singup btn_create"
                      type="button">
                      {t('dashboard.reservations.btn_pay')}
                    </button>
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
          <div className="container-room-description">
            <h4 className="page-header text-primary">
              <strong>{t('dashboard.reservations.heading_services')}</strong>
            </h4>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <strong>{t('dashboard.reservations.heading_included')}</strong>
                </p>
                <ul>
                  {room.services
                    ? (
                      room.services.map((service, index) =>
                        <li key={index}>{service.name}</li>
                      )
                    )
                    : null}
                </ul>
              </div>
              <div className="col-md-6">
                <p>
                  <strong>{t('dashboard.reservations.heading_extras')}</strong>
                </p>
                <ul>
                  {room.extras
                    ? (room.extras.map((service, index) =>
                      <li key={index}>{service.name}</li>
                    )) : null}
                </ul>
              </div>
            </div>
          </div>
          <section className='row'>
            <div className="container-direction mapa col-md-6">
              <div className="iframe-wrapper">
                <iframe
                  frameBorder="0"
                  src={
                    "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                    + center.latitude
                    + "%2C"
                    + center.longitude
                  }
                  title={t('dashboard.reservations.frame_center')}>
                </iframe>
              </div>
            </div>
            <div className="container-direction text col-md-6">
              <h4 className="page-header text-primary">
                <strong>{t('dashboard.reservations.heading_address')}</strong>
              </h4>
              <p>
                <strong>{center.name}</strong>
                {center.address ? (
                  center.address.split(",").map((row, index) =>
                    <span key={index} style={{ textTransform: "capitalize" }}>
                      <br />
                      {row.toLowerCase()}
                    </span>
                  )
                ) : (
                  null
                )}
              </p>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(RoomResevation);


// WEBPACK FOOTER //
// ./src/dashboard/reservations/RoomResevation.js